import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Calendar, Home as HomeIcon, ChevronRight } from "lucide-react";
import api from "@/lib/api";
import SEO from "@/components/SEO";
import { renderMarkdown } from "@/lib/markdown";

export default function BlogPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0); setPost(null); setNotFound(false);
    api.get(`/blog/${slug}`).then((r) => setPost(r.data)).catch(() => setNotFound(true));
  }, [slug]);

  if (notFound) return <div className="flex min-h-[50vh] items-center justify-center"><h1 className="font-display text-3xl font-bold text-navy">Article not found</h1></div>;
  if (!post) return <div className="mx-auto max-w-3xl px-4 py-10"><div className="h-96 w-full skeleton rounded-3xl" /></div>;

  const schema = {
    "@context": "https://schema.org", "@type": "BlogPosting", headline: post.title,
    image: post.cover_image, datePublished: post.created_at, description: post.excerpt,
    author: { "@type": "Organization", name: "Happy Holidays Wale" },
  };

  return (
    <>
      <SEO title={post.seo_title || post.title} description={post.meta_description || post.excerpt} image={post.cover_image} type="article" schema={schema} />
      <article className="mx-auto max-w-3xl px-4 py-10 md:px-8">
        <nav className="mb-6 flex items-center gap-2 text-sm text-gray-500">
          <Link to="/" className="flex items-center gap-1 hover:text-brandorange"><HomeIcon className="h-4 w-4" /> Home</Link>
          <ChevronRight className="h-4 w-4" /><Link to="/blog" className="hover:text-brandorange">Blog</Link>
          <ChevronRight className="h-4 w-4" /><span className="text-navy line-clamp-1">{post.title}</span>
        </nav>
        <div className="mb-4 flex flex-wrap gap-2">{(post.tags || []).map((t) => <span key={t} className="rounded-full bg-brandorange/10 px-3 py-1 text-xs font-semibold text-brandorange">{t}</span>)}</div>
        <h1 className="font-display text-3xl font-extrabold leading-tight text-navy sm:text-4xl">{post.title}</h1>
        <p className="mt-3 flex items-center gap-2 text-sm text-gray-400"><Calendar className="h-4 w-4" /> {new Date(post.created_at).toLocaleDateString("en-IN", { day: "numeric", month: "long", year: "numeric" })}</p>
        <img src={post.cover_image} alt={post.title} className="mt-6 aspect-[16/9] w-full rounded-3xl object-cover" />
        <div className="prose-blog mt-8" dangerouslySetInnerHTML={{ __html: renderMarkdown(post.content) }} />
        <div className="mt-12 rounded-3xl bg-navy p-8 text-center" style={{ backgroundColor: "#002244" }}>
          <h3 className="font-display text-2xl font-bold text-white">Inspired to travel?</h3>
          <Link to="/enquiry" className="btn-gradient mt-4 inline-block rounded-full px-6 py-3 font-bold">Plan Your Trip</Link>
        </div>
      </article>
    </>
  );
}
